import {TaskType} from "../Models/Game/TaskModel";
import {MiniGameTypeEnum} from "../Models/Game/MiniGameModel";

export default [
    {
        type: TaskType.Regular,
        score: 5,
        timeoutScoreForfeit: 5,
        failScoreForfeit: 0,
        time: [
            30,
            25,
            20
        ],
        miniGameType: MiniGameTypeEnum.stand_flyers,
        miniGameId: 0,
        text: 'Поправить брошюры',
    }, {
        type: TaskType.Regular,
        score: 20,
        timeoutScoreForfeit: 20,
        failScoreForfeit: 5,
        time: [
            30,
            25,
            20
        ],
        miniGameType: MiniGameTypeEnum.approve_the_loan,
        miniGameId: 0,
        text: 'Одобрить кредит',
    }, {
        type: TaskType.Regular,
        score: 30,
        timeoutScoreForfeit: 30,
        failScoreForfeit: 10,
        time: [
            30,
            25,
            20
        ],
        miniGameType: MiniGameTypeEnum.print_card,
        miniGameId: 0,
        text: 'Выпустить карту',
    }, {
        type: TaskType.Global,
        score: 40,
        timeoutScoreForfeit: 10,
        failScoreForfeit: 0,
        time: null,
        miniGameType: MiniGameTypeEnum.block_cards,
        miniGameId: 0,
        text: 'Заблокировать карту',
    }, {
        type: TaskType.Regular,
        score: 20,
        timeoutScoreForfeit: 20,
        failScoreForfeit: 0,
        time: [
            30,
            25,
            20
        ],
        miniGameType: MiniGameTypeEnum.currency_exchange,
        miniGameId: 0,
        text: 'Обменять валюту',
    }, {
        type: TaskType.Regular,
        score: 10,
        timeoutScoreForfeit: 10,
        failScoreForfeit: 0,
        time: [
            30,
            25,
            20
        ],
        miniGameType: MiniGameTypeEnum.lock_cell,
        miniGameId: 0,
        text: 'Закрыть почтовые ячейки',
    }, {
        type: TaskType.Global,
        score: 30,
        timeoutScoreForfeit: 0,
        failScoreForfeit: 0,
        time: null,
        miniGameType: MiniGameTypeEnum.dinner,
        miniGameId: 0,
        text: 'Пообедать',
    }, {
        type: TaskType.Regular,
        score: 20,
        timeoutScoreForfeit: 20,
        failScoreForfeit: 0,
        time: [
            30,
            25,
            20
        ],
        miniGameType: MiniGameTypeEnum.send_a_letter,
        miniGameId: 0,
        text: 'Отправить письмо',
    }, {
        type: TaskType.Global,
        score: 30,
        timeoutScoreForfeit: 0,
        failScoreForfeit: 0,
        time: null,
        miniGameType: MiniGameTypeEnum.electricity,
        miniGameId: 0,
        text: 'Включить электричество',
    }, {
        type: TaskType.Regular,
        score: 60,
        timeoutScoreForfeit: 60,
        failScoreForfeit: 20,
        time: [
            30,
            25,
            20
        ],
        miniGameType: MiniGameTypeEnum.bussines_trip,
        miniGameId: 0,
        text: 'Подготовить командировку',
    }
];
